import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useModalReviews } from './hooks';
import { VersionTable } from './CustomTable';
import { LoadingSkeleton } from './LoadingSkeleton';
import * as S from './styles';

interface ModalReviewsProps {
	report: any;
	open?: boolean;
	onCancel: () => void;
}

export function ModalReviews({ report, open = false, onCancel }: Readonly<ModalReviewsProps>): JSX.Element {
	const reviews = useModalReviews({ data: report?.reviews || [] });

	return (
		<S.ModalStyled
			centered
			open={open}
			width={1118}
			footer={null}
			title={<S.CustomTitle level={3}>{I18n.get('Versions')}</S.CustomTitle>}
			onCancel={onCancel}
			destroyOnClose={true}
		>
			<Row justify="space-between">
				<Col xs={4}>
					<Row justify="center">
						<S.CustomParagraph strong>{I18n.get('Version')}</S.CustomParagraph>
					</Row>
				</Col>
				<Col>&nbsp;</Col>
				<Col xs={14} style={{ margin: 0 }}>
					<Row justify="center">
						<S.CustomParagraph strong>{I18n.get('Files')}</S.CustomParagraph>
					</Row>
				</Col>
				<Col>&nbsp;</Col>
				<Col xs={3}>
					<Row justify="center">
						<S.CustomParagraph strong>{I18n.get('Date')}</S.CustomParagraph>
					</Row>
				</Col>
				<Col>&nbsp;</Col>
				<Col xs={2} />
			</Row>
			<LoadingSkeleton loading={false} />
			<VersionTable versions={reviews} reportId={report?.id} />
		</S.ModalStyled>
	);
}
